
const TIMTags = (doc, data, clinica, valorIva, typeDocumentInvoice) => {
    var TIM = doc.createElement("TIM");

    //La Factura es Retenida o tiene Retencion
    var TIM_1 = doc.createElement("TIM_1");// indica si el elemento es retenido o de retencion
    TIM_1.innerHTML = "true";
    TIM.appendChild(TIM_1);

    //Valor Total de la Retencion
    var TIM_2 = doc.createElement("TIM_2");
    TIM_2.innerHTML = valorIva; //valor IVA
    TIM.appendChild(TIM_2);

    var TIM_3 = doc.createElement("TIM_3");//moneda de impouesto
    TIM_3.innerHTML = "COP";
    TIM.appendChild(TIM_3);

    TIM.appendChild(IMPTags(doc, data, clinica, valorIva));

    return TIM;
}

const IMPTags = (doc, data, clinica, valorIva) => {
    var IMP = doc.createElement("IMP");

    var IMP_1 = doc.createElement("IMP_1"); //tipo clase de impuesto
    IMP_1.innerHTML = "01";
    IMP.appendChild(IMP_1);

    var IMP_2 = doc.createElement("IMP_2");
    IMP_2.innerHTML = parseInt(data.detalles_comerciales.subtotal) - parseInt(valorIva);
    IMP.appendChild(IMP_2);

    var IMP_3 = doc.createElement("IMP_3");
    IMP_3.innerHTML = "COP";
    IMP.appendChild(IMP_3);

    var IMP_4 = doc.createElement("IMP_4");
    IMP_4.innerHTML = valorIva; //IVA
    IMP.appendChild(IMP_4);

    var IMP_5 = doc.createElement("IMP_5");
    IMP_5.innerHTML = "COP";
    IMP.appendChild(IMP_5);

    var IMP_6 = doc.createElement("IMP_6");
    IMP_6.innerHTML = 19.00;
    IMP.appendChild(IMP_6);

    return IMP;
}

export default TIMTags;